import { render, staticRenderFns } from "./ViewBrowsinghistory.vue?vue&type=template&id=9e807bd6&scoped=true"
import script from "./ViewBrowsinghistory.vue?vue&type=script&lang=js"
export * from "./ViewBrowsinghistory.vue?vue&type=script&lang=js"
import style0 from "./ViewBrowsinghistory.vue?vue&type=style&index=0&id=9e807bd6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e807bd6",
  null
  
)

export default component.exports